import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CasoTareaService } from '../../../services/casos_tareas.service';
import { UserService } from 'src/app/services/user.service';
import { NotificacionService } from 'src/app/services/notificaciones.service';
import { AsignarUsuarioModalComponent } from './asignar-usuario-modal/asignar-usuario-modal.component';
import { RolesPermisosService } from 'src/app/services/roles_permisos.service';
import { TypeOfCases, Units } from '@utils/type-cases';

@Component({
  selector: 'crear-caso',
  templateUrl: './c-caso.component.html',
  styleUrls: ['./c-caso.component.scss'],
})
export class CrearCasoTareasComponent implements OnInit {
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;

  modal_type: string = 'Crear';

  submit: boolean = false;

  users: any[] = null;

  files: any[] = [];

  beforeAsignado: string;

  form: FormGroup = this.fb.group({
    unidad: [undefined, [Validators.required]],
    tipo_caso: ['', [Validators.required]],
    descripcion: ['', [Validators.required]],
    asignadoA: [''],
    files: [],
    asignadoAID: [''],
    aprobacion: [false],
    estado: ['Por Asignar', [Validators.required]],
    creadoPor: [sessionStorage.getItem('id_usuario'), [Validators.required]],
    deleted: [false],
  });

  formRas: FormGroup = this.fb.group({
    riskType: ['', [Validators.required]],
    region: ['', [Validators.required]],
    personType: ['', [Validators.required]],
    riskLevel: ['', [Validators.required]],
  });

  get showFormRas() {
    const caseType = this.form.controls.tipo_caso.value;
    return caseType == 'Análisis de RAS';
  }

  get canCreate() {
    if (this.showFormRas) {
      return this.formRas.valid && this.form.valid;
    } else {
      return this.form.valid;
    }
  }

  tipo_casos: string[] = [];
  valueCase: string;
  unidades: Units[] = [];

  //Textos que cambian si el tipo de caso es externos

  text = {
    Caso: 'Caso',
  };

  changeTipocaso(value) {
    this.tipo_casos = TypeOfCases.getCasesByUnit([value]);
  }

  constructor(
    public _caso: CasoTareaService,
    public fb: FormBuilder,
    public _snackbar: MatSnackBar,
    public _users: UserService,
    public dialogRef: MatDialogRef<CrearCasoTareasComponent>,
    public _notification: NotificacionService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _rolesPermisosService: RolesPermisosService // private validarDocumentoService:ValidacionDocumentoService, // private autorizacionTransaccionService:AutorizacionTransaccionService
  ) {
    this.unidades = TypeOfCases.units;

    const { unidad } = this.data;

    if (unidad == 'Inteligencia' || unidad == 'inteligencia') {
      this.unidades = ['Inteligencia'];
    } else if (unidad == 'Asuntos Internos' || unidad == 'internos') {
      this.unidades = ['Asuntos Internos'];
    } else if (unidad == 'Asuntos Externos' || unidad == 'externos') {
      this.unidades = ['Asuntos Externos'];
    } else if (unidad == 'Gestión de Fraudes' || unidad == 'fraudes') {
      this.unidades = ['Gestión de Fraudes'];
    } else if (unidad == 'ras' || unidad == 'Supervision de OOFF') {
      this.unidades = ['Supervision de OOFF'];
    }
  }

  async ngOnInit() {
    this.form.controls['asignadoA'].disable();
    this.beforeAsignado = this.data?.asignadoA;
    await this.getUsers();
    if (this.data.edit) {
      this.form.controls.asignadoAID.setValue(this.data.asignadoAID);
      this.form.controls.asignadoA.setValue(this.data.asignadoA);
      this.form.controls.estado.setValue(this.data.estado);
      this.form.controls.unidad.setValue(this.data.unidad);
      this.form.controls.tipo_caso.setValue(this.data.tipo_caso);
      this.asignadoA = this.data.asignadoA;
      this.form.controls.creadoPor.setValue(this.data.creadoPor);
      this.form.controls.deleted.setValue(this.data.deleted);
      this.form.controls.descripcion.setValue(this.data.descripcion);
      this.form.controls.files.setValue(this.data.files);
      this.modal_type = 'Editar';
      this.files = this.data.files;
      this.changeTipocaso(this.data.unidad);
      if (this.data.tipo_caso == 'RAS') {
        const { riskType, region, personType, riskLevel } = this.data;

        this.formRas.setValue({ riskType, region, personType, riskLevel });
      }
    }
  }

  async getUsers() {
    const response: any = await this._users.getUsers().toPromise();
    this.users = response.payload;
    if (
      this.data.unidad == 'externos' ||
      this.data.unidad == 'Asuntos Externos'
    ) {
      this._rolesPermisosService
        .takeUser([
          'Analista de Casos Asuntos Externos',
          'Administrador Casos de Asuntos Externos',
        ])
        .subscribe((response) => {
          this.users = response.payload.data;
        });
    } else if (
      this.data.unidad == 'internos' ||
      this.data.unidad == 'Asuntos Internos'
    ) {
      this._rolesPermisosService
        .takeUser([
          'Analista de Casos Asuntos Internos',
          'Administrador Casos de Asuntos Internos',
        ])
        .subscribe((response) => {
          this.users = response.payload.data;
        });
    } else if (
      this.data.unidad == 'inteligencia' ||
      this.data.unidad == 'Inteligencia'
    ) {
      this._rolesPermisosService
        .takeUser([
          'Analista de Casos Inteligencia',
          'Admininistrador Casos de inteligencia',
        ])
        .subscribe((response) => {
          this.users = response.payload.data;
        });
    } else if (
      this.data.unidad == 'fraudes' ||
      this.data.unidad == 'Gestión de Fraudes'
    ) {
      this._rolesPermisosService
        .takeUser([
          'Analista de Gestión de Fraudes',
          'Gerente Gestión de Fraudes',
          'Supervisor Gestión de Fraudes',
        ])
        .subscribe((response) => {
          this.users = response.payload.data;
        });
    } else if (
      this.data.unidad == 'ras' ||
      this.data.unidad == 'Supervision de OOFF'
    ) {
      this._rolesPermisosService
        .takeUser(['analystRas', 'managerRas', 'complianceOfficerRas'])
        .subscribe((response) => {
          this.users = response.payload.data;
        });
    }
  }

  async crear() {
    let value = this.form.value;

    value.asignadoA = this.asignadoA;

    if (this.showFormRas) {
      value = Object.assign({}, value, this.formRas.value);
    }

    const id = this.users.find((user: any) => user.correo === this.asignadoA);

    if (id) value.asignadoAID = id.id_usuarios;

    if (this.data.edit) {
      this.data.historial.push({
        usuario: `${sessionStorage.getItem('correo')}`,
        realizo: `Caso editado`,
        date: new Date(),
      });
      value.historial = this.data.historial;
    } else
      value.historial = [
        {
          usuario: `${sessionStorage.getItem('correo')}`,
          realizo: `Caso creado`,
          date: new Date(),
        },
      ];

    value.files = this.files;

    this.submit = true;

    if (this.modal_type == 'Crear') {
      this._caso.post(value).subscribe(async (response: any) => {
        this.finish('Caso creado con Éxito');

        if (id) {
          this._notification
            .asignarCaso(id.id_usuarios, response.numero_caso)
            .toPromise();
        }
      });
    } else {
      this._caso.put(this.data._id, value).subscribe(async (response: any) => {
        this.finish('Caso editado con Éxito');

        if (id) {
          if (this.beforeAsignado != value.asignadoA) {
            this._notification
              .asignarCaso(id.id_usuarios, response.numero_caso)
              .toPromise();
          }
        }
      });
    }
  }

  finish(message: string) {
    this._snackbar.open(message, 'cerrar');
    this.submit = false;
    this.dialogRef.close(true);
  }

  asignadoA;
  openDialogSelectUser() {
    if (this.data && this.data != 'inteligencia') {
      this.data.users = this.users;
    }
    if (this.data == null || this.data == 'inteligencia') {
      this.data = { users: this.users };
    } else {
      this.data = this.data;
    }
    let data = this.data;
    const dialogRef = this.dialog.open(AsignarUsuarioModalComponent, {
      data,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((response: any) => {
      this.form.controls.asignadoA.setValue(response.correo);
      this.form.controls.asignadoAID.setValue(response.id);
      this.form.value.asignadoA = response.correo;
      this.form.value.asignadoAID = response.id;
      this.asignadoA = response.correo;
      this.beforeAsignado;
    });
  }
}
